import React, { PropsWithChildren, HTMLAttributes } from 'react';
import { InfoIcon } from './svg/Icons';
import { OverlayTrigger, Popover } from 'react-bootstrap';

export function Info(props: PropsWithChildren<HTMLAttributes<any>>)
{

  const { children, style, ...rest } = props;
  const popover = (
    <Popover id="popover-basic">
      {children ?? null}
    </Popover>
  );

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={popover}
    >
      <span className="info" {...rest}>
        <InfoIcon style={style ?? { width: '1.9em', height: '1.8em', fill: '#deb535', marginTop: 3 }} />
      </span>
    </OverlayTrigger>
  );
}

